<div class="yc-layout">
  <yc-panel
    [title]="'common:hdrSystemHealthDashboard' | ycI18n: 'System Health Dashboard'">
  </yc-panel>

  <div class="yc-layout-table">
    @if (tableDataFactory) {
      <yc-table
        key="SYSTEM_HEALTH_DASHBOARD"
        [tableDataFactory]="tableDataFactory"
        [simple]="true"
        [hideTableFilters]="true"
        [hideTableOptions]="true"
        [hidePagination]="true">
        <!-- Health Indicator Name -->
      <ng-container *ycTableColumn="'admin:textHealthIndicatorName';
        let row;
        prop: 'healthIndicatorName'">
          {{ row.healthIndicatorName }}
        </ng-container>
        <!-- Health Indicator Error Count -->
      <ng-container *ycTableColumn="'admin:textHealthIndicatorErrorCount';
        let row;
        prop: 'healthIndicatorErrorCount'">
          {{ row.healthIndicatorErrorCount }}
        </ng-container>
        <!-- Health Indicator Details -->
      <ng-container *ycTableColumn="'common:textActions'
        let row;
        prop: '',
        filterType: '',
        class: 'actions',
        locked: true">
          @if (row.healthIndicatorErrorCount > 0) {
            <yc-button
              [icon]="true"
              [value]="'common:btnOptions' | ycI18n"
              [langKey]="'admin:textViewHealthIndicatorDetails'"
              [defaultText]="'Errors'"
              (onClick)="viewHealthIndicatorDetails(row)">
            </yc-button>
          }
        </ng-container>
      </yc-table>
    }
  </div>
</div>